export const SET_BORROWER_AFFILIATE_CODE_AND_NAME =
  'SET_BORROWER_AFFILIATE_CODE_AND_NAME'
export const SET_INVESTOR_AFFILIATE_CODE_AND_NAME =
  'SET_INVESTOR_AFFILIATE_CODE_AND_NAME'
